import React from 'react';
import {Layout, Menu, Avatar, Dropdown, Button} from 'antd';
import {UserOutlined, LogoutOutlined, MenuUnfoldOutlined, MenuFoldOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import '../styles/Header.css';

const {Header} = Layout;

const AppHeader = ({collapsed, toggleCollapsed}) => {
    const navigate = useNavigate();
    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    function handleMy() {
        navigate("/my")
    }

    const userMenu = (
        <Menu
            items={[
                {
                    key: '1',
                    icon: <UserOutlined/>,
                    label: '个人中心',
                    onClick: handleMy
                },
                {
                    type: 'divider'
                },
                {
                    key: '2',
                    icon: <LogoutOutlined/>,
                    label: '退出登录',
                    onClick: handleLogout
                }
            ]}
        />
    );

    return (
        <Header className="app-header">
            <div className="header-left">
                <Button
                    type="text"
                    icon={collapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
                    onClick={toggleCollapsed}
                    className="trigger-button"
                />
                <div className="logo">
                    <h1>染发配方管理系统</h1>
                </div>
            </div>

            {/*<Dropdown*/}
            {/*    overlay={userMenu}*/}
            {/*    trigger={['click']}  // 点击触发*/}
            {/*    placement="bottomRight"  // 菜单弹出位置*/}
            {/*>*/}
            {/*    <div className="user-info" style={{ cursor: 'pointer' }}>*/}
            {/*        <span className="username">管理员</span>*/}
            {/*        <Avatar icon={<UserOutlined />} />*/}
            {/*    </div>*/}
            {/*</Dropdown>*/}
            <div className="header-right">
                <Dropdown  overlay={userMenu} trigger={['click']} placement="bottomRight">
                    <div className="user-info">
                        <span className="username">管理员</span>
                        <Avatar icon={<UserOutlined />}/>
                    </div>
                </Dropdown>
            </div>
        </Header>
    );
};

export default AppHeader; 